const FilterTypes = Object.freeze({
  Boolean: 'boolean',
  String: 'string',
  Date: 'date',
  Number: 'number',
  Search: 'search',
});

export default FilterTypes;
